/**
 * Service Type Alternative Names Service
 * Admin management of commissioner-language alternative names per canonical
 * service type. These are heavily cached server-side and used by tender
 * ingestion/matching (tender.server) — see backend
 * src/services/serviceTypeAlternativeNames.service.js.
 */
import { api } from './api'

export const serviceTypeAlternativeNamesService = {
    async getAll() {
        const res = await api.get('/admin/service-type-alternative-names')
        if (!res.success) throw new Error('Failed to fetch service type alternative names')
        return res.data || []
    },

    async update(id, { serviceType, category, alternativeNames }) {
        const res = await api.put(`/admin/service-type-alternative-names/${id}`, {
            serviceType,
            category,
            alternativeNames,
        })
        if (!res.success) throw new Error('Failed to update service type')
        return res.data
    },

    async create(serviceType, category, alternativeNames) {
        const res = await api.post('/admin/service-type-alternative-names', {
            serviceType,
            category,
            alternativeNames,
        })
        if (!res.success) throw new Error('Failed to create service type')
        return res.data
    },

    /** Hide a service type from the organisation picker without breaking existing selections or classifications. */
    async setActive(id, isActive) {
        const res = await api.patch(`/admin/service-type-alternative-names/${id}/active`, { isActive })
        if (!res.success) throw new Error('Failed to update service type')
        return res.data
    },

    async setCategoryActive(category, isActive) {
        const res = await api.patch('/admin/service-type-alternative-names/category/active', { category, isActive })
        if (!res.success) throw new Error('Failed to update category')
        return res.data
    },

    async remove(id) {
        const res = await api.delete(`/admin/service-type-alternative-names/${id}`)
        if (!res.success) throw new Error('Failed to delete service type')
    },

    async removeCategory(category) {
        const res = await api.delete(`/admin/service-type-alternative-names/category?category=${encodeURIComponent(category)}`)
        if (!res.success) throw new Error('Failed to delete category')
    },
}

export default serviceTypeAlternativeNamesService
